<template>
  <div>
    <div class="main-button-bar">
      <el-button type="primary" size="small" @click="svUser">新增</el-button>
    </div>

    <el-table
      :data="page.records"
      stripe
      style="width: 100%"
      :height="this.$tools.mainHeight() - 84"
      class="user-setting-table"
    >
      <el-table-column prop="acct" label="账号" width="180"> </el-table-column>
      <el-table-column prop="name" label="姓名" width="180"> </el-table-column>
      <el-table-column prop="phone" label="电话" width="180"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180">
        <template slot-scope="scope">
          {{$tools.timestampToTime(scope.row.createTime)}}
        </template>
      </el-table-column>
      <el-table-column prop="grade" label="分数" width="100"> </el-table-column>
      <el-table-column prop="roles" label="角色">
        <template slot-scope="scope">
          <el-tag
            size="small"
            v-if="
              scope.row.roles != null && scope.row.roles.indexOf('AD') != -1
            "
            type="danger"
            >管理员</el-tag
          >
          <el-tag
            size="small"
            v-if="
              scope.row.roles != null && scope.row.roles.indexOf('IU') != -1
            "
            type="warning"
            >要员</el-tag
          >
          <el-tag
            size="small"
            v-if="
              scope.row.roles != null && scope.row.roles.indexOf('US') != -1
            "
            >员工</el-tag
          >
          <el-tag
            size="small"
            v-if="
              scope.row.roles != null && scope.row.roles.indexOf('FC') != -1
            "
            >工厂用户</el-tag
          >
          <el-tag
            size="small"
            v-if="
              scope.row.roles != null && scope.row.roles.indexOf('TB') != -1
            "
            >B端用户</el-tag
          >
          <el-tag
            size="small"
            v-if="
              scope.row.roles != null && scope.row.roles.indexOf('BM') != -1
            "
            >B端管理员</el-tag
          >
                    <el-tag
            size="small"
            v-if="
              scope.row.roles != null && scope.row.roles.indexOf('BB') != -1
            "
            >B端业务员</el-tag
          >
          <el-tag
            size="small"
            v-if="
              scope.row.roles != null && scope.row.roles.indexOf('TC') != -1
            "
            >C端用户</el-tag
          >
                    <el-tag
            size="small"
            v-if="
              scope.row.roles != null && scope.row.roles.indexOf('CB') != -1
            "
            >C端业务员</el-tag
          >          <el-tag
            size="small"
            v-if="
              scope.row.roles != null && scope.row.roles.indexOf('TC') != -1
            "
            >C端用户</el-tag
          >
          <el-tag
            size="small"
            v-if="
              scope.row.roles != null && scope.row.roles.indexOf('CM') != -1
            "
            >C端管理员</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100">
         <template slot-scope="scope">
            <el-tag size="small" v-if="scope.row.status == 'IN'" type="success">使用中</el-tag>
            <el-tag size="small" v-if="scope.row.status == 'DS'" type="warning">禁用</el-tag>
         </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="200" prop="status">
        <template slot-scope="scope">
          <el-button type="text" size="small" v-on:click="upPswd(scope.row.id)"
            >密码
          </el-button>
          <el-button
            type="text"
            size="small"
            @click="upRole(scope.row.id, scope.row.roles)"
            >角色
          </el-button>
           <el-button
            type="text"
            size="small"
            @click="upAuth(scope.row.id)"
            >权限
          </el-button>
          <el-button
            type="text"
            size="small"
            v-if="scope.row.status != null && scope.row.status == 'IN'"
            v-on:click="upStatus(scope.row.id, 'DS')"
          >
            禁用</el-button
          >
          <el-button
            type="text"
            size="small"
            v-if="!scope.row.status || scope.row.status == 'DS'"
            v-on:click="upStatus(scope.row.id, 'IN')"
          >
            启用</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      small
      layout="total, prev, pager, next"
      :total="page.total"
      @current-change="getUser"
    ></el-pagination>
    <el-dialog :visible.sync="showUserDialog" title="新增用户" width="30%">
      <el-form
        label-width="60px"
        label-position="top"
        :rules="rules"
        :model="user"
        ref="user"
      >
        <el-form-item label="账号" prop="acct">
          <el-input v-model="user.acct"></el-input>
        </el-form-item>

        <el-form-item label="名称" prop="name">
          <el-input v-model="user.name"></el-input>
        </el-form-item>
         <el-form-item label="电话" prop="phone">
          <el-input v-model="user.phone"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" v-on:click="dosvUser"  class="op-button"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showUserStatus" title="编辑角色" width="30%">
      <div>
        <el-checkbox label="AD" v-model="roles">管理员</el-checkbox>
        <el-checkbox label="IU" v-model="roles">要员</el-checkbox>
        <el-checkbox label="US" v-model="roles">员工</el-checkbox>
        <el-checkbox label="FC" v-model="roles">工厂用户</el-checkbox>
        <el-checkbox label="TB" v-model="roles">B端用户</el-checkbox>
        <el-checkbox label="BB" v-model="roles">B端业务员</el-checkbox>
        <el-checkbox label="BM" v-model="roles">B端管理员</el-checkbox>
        <el-checkbox label="TC" v-model="roles">C端用户</el-checkbox>
        <el-checkbox label="CB" v-model="roles">C端业务员</el-checkbox>
        <el-checkbox label="CM" v-model="roles">C端管理员</el-checkbox>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" v-on:click="doupRole" class="op-button"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showUserAuth" title="编辑权限" width="30%">
      <settings-role :isRole="false" :userId="userId" @afterAdd="afterAuth"></settings-role>
    </el-dialog>
  </div>
</template>

<script>
import SettingsRole from './Settings-role.vue';
export default {
    components: { SettingsRole },
  data() {
    return {
      page: { size: 10, current: 1, total: 0, records: [] },
      user: { name: "", acct: "", roles: "" },
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 6 个字符",
            trigger: "blur",
          },
        ],
        acct: [
          { required: true, message: "请输入账号", trigger: "blur" },
          {
            min: 3,
            max: 10,
            message: "长度在 5 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      showUserDialog: false,
      showUserStatus: false,
      showUserAuth: false,
      roles: [],
      userId: 1
    };
  },
  methods: {
    getUser(current) {
      if (current) {
        this.page.current = current;
      }

      let _this = this;

      _this.$http.post(
        ["/user/list", this.page],
        [
          function (data) {
            _this.page = data;
          },
        ], ".user-setting-table"
      );
    },
    upStatus(id, val) {
      let _this = this;

      _this.$tConfirm.show(
        val == "DS" ? "确认禁用？" : "确认启用？",
        function () {
          _this.$http.post(
            ["/user/update", { id: id, status: val }],
            [function() {_this.getUser();}],
            ".user-setting-table"
          );
        }
      );
    },
    upPswd(id) {
      let _this = this;
      _this.$tPrompt.show("新密码", function (value) {
        _this.$http.post(
          ["/user/update", { id: id, pswd: value }],
          [function() {_this.getUser();}],
          ".user-setting-table"
        );
      });
    },
    svUser() {
      this.showUserDialog = true;
    },
    dosvUser() {
      let _this = this;

      this.$refs["user"].validate((valid) => {
        if (valid) {
          _this.$http.post(
            ["/user/save", _this.user],
            [
              function () {
                _this.showUserDialog = false;
                _this.user = {};
                _this.getUser();
              },
            ], '.op-button'
          );
        }
      });
    },
    upRole(id, roles) {
      this.showUserStatus = true;
      this.user = {};
      this.user.id = id;
      this.roles = [];

      let temp = roles.split("-");
      
      for (var i in temp) {
          if (temp[i]) {
            this.roles.push(temp[i]);
          }
      }
    },
    doupRole() {
      let _this = this;

      _this.user.roles = _this.roles.join("-");

      _this.$http.post(
        ["/user/update", this.user],
        [
          function () {
            _this.showUserStatus = false;
            _this.user = {};
            _this.getUser();
          }
        ],
        ".user-setting-table"
      );
    },
    upAuth(userId) {
      this.userId = userId;
      this.showUserAuth = true;
    },
    afterAuth() {
      this.showUserAuth = false;
    }
  },
  mounted() {
    this.getUser();
  },
};
</script>
<style scoped>
</style>>
